import { useState } from 'react';
import DataTable from '../../components/DataTable';
import Modal from '../../components/Modal';
import { useApi } from '../../hooks/useApi';
import logger from "../../utils/logger";
const emptyForm = {
  first_name: '',
  last_name: '',
  phone: '',
  email: '',
  position: '',
  crm_company_id: ''
};
function ContactsTable({
  contacts,
  companies,
  onContactsChange
}) {
  const {
    request,
    showStatus
  } = useApi();
  const [modalOpen, setModalOpen] = useState(false);
  const [activeContact, setActiveContact] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const openCreate = () => {
    setActiveContact(null);
    setForm(emptyForm);
    setModalOpen(true);
  };
  const openEdit = contact => {
    setActiveContact(contact);
    setForm({
      first_name: contact.first_name || '',
      last_name: contact.last_name || '',
      phone: contact.phone || '',
      email: contact.email || '',
      position: contact.position || '',
      crm_company_id: contact.crm_company_id || ''
    });
    setModalOpen(true);
  };
  const handleSave = async event => {
    event.preventDefault();
    // Пустая компания уходит как null: пустая строка не UUID, сервер отвечал 422.
    const payload = { ...form, crm_company_id: form.crm_company_id || null };
    try {
      if (activeContact) {
        const updated = await request(`/api/v1/crm/contacts/${activeContact.id}`, {
          method: 'PATCH',
          body: JSON.stringify(payload)
        });
        onContactsChange(contacts.map(item => item.id === updated.id ? updated : item));
        showStatus('success', 'Контакт обновлён.');
      } else {
        const created = await request('/api/v1/crm/contacts', {
          method: 'POST',
          body: JSON.stringify(payload)
        });
        onContactsChange([created, ...contacts]);
        showStatus('success', 'Контакт добавлен.');
      }
      setModalOpen(false);
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось сохранить контакт: ' + (error?.message || 'проверьте поля'));
    }
  };
  const handleDelete = async () => {
    if (!activeContact || !window.confirm(`Удалить контакт «${[activeContact.first_name, activeContact.last_name].filter(Boolean).join(' ') || activeContact.email || ''}»?`)) return;
    try {
      await request(`/api/v1/crm/contacts/${activeContact.id}`, { method: 'DELETE' });
      onContactsChange(contacts.filter(item => item.id !== activeContact.id));
      showStatus('success', 'Контакт удалён.');
      setModalOpen(false);
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось удалить: ' + (error?.message || ''));
    }
  };
  const columns = [{
    key: 'name',
    label: 'Контакт',
    render: row => [row.first_name, row.last_name].filter(Boolean).join(' ') || 'Без имени'
  }, {
    key: 'phone',
    label: 'Телефон',
    render: row => row.phone || '—'
  }, {
    key: 'email',
    label: 'Email',
    render: row => row.email || '—'
  }, {
    key: 'position',
    label: 'Должность',
    render: row => row.position || '—'
  }];
  return <div className="crm__block">
            <div className="crm__toolbar">
                <div className="crm__toolbar-left">
                    <h4>Контакты</h4>
                </div>
                <button type="button" onClick={openCreate}>
                    Добавить контакт
                </button>
            </div>

            <DataTable className="crm__table" headerClassName="crm__row crm__row--head crm__row--contacts" rowClassName="crm__row crm__row--clickable crm__row--contacts" columns={columns} rows={contacts} getRowKey={row => row.id} onRowClick={openEdit} />
      

            <Modal open={modalOpen} onClose={() => setModalOpen(false)} title="Контакт">
                <form className="panel__form" onSubmit={handleSave}>
                    <div className="panel__grid">
                        <label>
                            Имя
                            <input type="text" value={form.first_name} onChange={event => setForm({
              ...form,
              first_name: event.target.value
            })} />
              
                        </label>
                        <label>
                            Фамилия
                            <input type="text" value={form.last_name} onChange={event => setForm({
              ...form,
              last_name: event.target.value
            })} />
              
                        </label>
                    </div>
                    <div className="panel__grid">
                        <label>
                            Телефон
                            <input type="text" value={form.phone} onChange={event => setForm({
              ...form,
              phone: event.target.value
            })} />
              
                        </label>
                        <label>
                            Email
                            <input type="email" value={form.email} onChange={event => setForm({
              ...form,
              email: event.target.value
            })} />
              
                        </label>
                    </div>
                    <div className="panel__grid">
                        <label>
                            Должность
                            <input type="text" value={form.position} onChange={event => setForm({
              ...form,
              position: event.target.value
            })} />
              
                        </label>
                        <label>
                            Компания
                            <select value={form.crm_company_id || ''} onChange={event => setForm({
              ...form,
              crm_company_id: event.target.value
            })}>
                
                                <option value="">—</option>
                                {companies.map(companyItem => <option key={companyItem.id} value={companyItem.id}>
                                        {companyItem.name}
                                    </option>)}
                            </select>
                        </label>
                    </div>
                    <div className="panel__actions">
                        {activeContact && (
                            <button type="button" className="ghost danger" onClick={handleDelete}>
                                Удалить
                            </button>
                        )}
                        <button type="button" className="ghost" onClick={() => setModalOpen(false)}>
                            Отмена
                        </button>
                        <button type="submit">Сохранить</button>
                    </div>
                </form>
            </Modal>
        </div>;
}
export default ContactsTable;
